import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  loginService,
  logoutService,
} from "../../../services/auth/auth.service";
import { getUserFromToken, isTokenExpired } from "../../../utils/jwt";
import Cookies from "js-cookie";

export const loginThunk = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      return await loginService(credentials);
    } catch (error) {
      const data = error.response?.data || {};
      // Preferir el primer error de campo (más limpio que el `message` crudo
      // que puede venir como "'campo': texto").
      const firstFieldError = data.errors
        ? Object.values(data.errors).flat()[0]
        : null;

      const message =
        data.detail ||
        firstFieldError ||
        data.message ||
        "Credenciales inválidas";

      return rejectWithValue(message);
    }
  },
);
const tokenFromCookie = Cookies.get("access_token");

const isValidToken = tokenFromCookie && !isTokenExpired(tokenFromCookie);

const initialState = {
  user: isValidToken ? getUserFromToken(tokenFromCookie) : null,
  accessToken: isValidToken ? tokenFromCookie : null,
  loading: false,
  error: null,
  isAuthenticated: isValidToken,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      logoutService();
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setTokens: (state, action) => {
      const { access, user: apiUser } = action.payload;
      state.accessToken = access;
      // Decodificar el JWT y mezclar con los datos del usuario de la API
      const decoded = getUserFromToken(access) || {};
      state.user = { ...decoded, ...apiUser };
      state.isAuthenticated = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        const { access } = action.payload;

        state.loading = false;
        state.accessToken = access;
        state.user = getUserFromToken(access);
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError, setTokens } = authSlice.actions;
export default authSlice.reducer;
